import { TIdToPageMap } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioCapsule81 } from './pages'

export const ID_TO_PAGE_MAP_STYLIO_CAPSULE_81: TIdToPageMap = {
  [PageIdStylioCapsule81.SUBSCRIPTIONS_CAPSULE_81]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_81/pages/CapsuleSubscriptionPage'
      ).then((m) => ({
        default: m.CapsuleSubscriptionPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_81/pages/CapsuleSubscriptionPage'),
  },
  [PageIdStylioCapsule81.SUB_UPSELL_CAPSULE_81]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule_81/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_81/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioCapsule81.FACE_STYLING_PDF_UPSELL_CAPSULE_81]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_81/pages/third-pdf-upsell/ThirdPdfUpsell'
      ).then((m) => ({
        default: m.ThirdPdfUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_81/pages/third-pdf-upsell/ThirdPdfUpsell'
      ),
  },
  [PageIdStylioCapsule81.PROPORTIONS_PDF_UPSELL_CAPSULE_81]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule_81/pages/ProportionsPdfUpsell').then(
        (m) => ({
          default: m.ProportionsPdfUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_81/pages/ProportionsPdfUpsell'),
  },
  [PageIdStylioCapsule81.DOWNLOAD_CAPSULE_81]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_81/pages/download-capsule/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_81/pages/download-capsule/DownloadDefault'
      ),
  },
}
